import React from 'react';

import { Link, Title } from './styles';

export default function itemBreadcrumb(route, params, routes, paths) {
  return (
    <Title strong>
      {route.path ? (
        <Link to={route.path}>{route.breadcrumbName}</Link>
      ) : (
        route.breadcrumbName
      )}
    </Title>
  );
}
